import { API_BASE_URL, endpoints } from './config';
import { authHeadersForGet, authHeadersJson } from './http';
import {
  BulkSupplierProductItem,
  ExtractSupplierProductsResponse,
  SupplierProduct,
  SupplierProductsResponse,
} from '../types/supplierProduct';

export interface SupplierProductSearchParams {
  search?: string;
  supplierClientReference?: string;
  categoryReference?: string;
  page?: number;
  limit?: number;
}

export const supplierProductsApi = {
  extract: async (
    messageReferences: string[],
    supplierClientReference: string,
  ): Promise<ExtractSupplierProductsResponse> => {
    const response = await fetch(`${API_BASE_URL}${endpoints.supplierProducts.extract}`, {
      method: 'POST',
      headers: authHeadersJson(),
      body: JSON.stringify({ messageReferences, supplierClientReference }),
    });
    if (!response.ok) {
      throw new Error('No se pudieron extraer productos del mensaje');
    }
    return response.json();
  },

  bulkCreate: async (
    supplierClientReference: string,
    items: BulkSupplierProductItem[],
  ): Promise<SupplierProduct[]> => {
    const response = await fetch(`${API_BASE_URL}${endpoints.supplierProducts.bulk}`, {
      method: 'POST',
      headers: authHeadersJson(),
      body: JSON.stringify({ supplierClientReference, items }),
    });
    if (!response.ok) {
      throw new Error('No se pudieron guardar los productos de proveedor');
    }
    return response.json();
  },

  getAll: async (
    params?: SupplierProductSearchParams,
  ): Promise<SupplierProductsResponse> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.supplierProducts.getAll(params)}`,
      { headers: authHeadersForGet() },
    );
    return response.json();
  },

  search: async (term: string): Promise<SupplierProduct[]> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.supplierProducts.search(term)}`,
      { headers: authHeadersForGet() },
    );
    return response.json();
  },

  updateOffer: async (
    productReference: string,
    offerReference: string,
    price: number,
  ): Promise<SupplierProduct> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.supplierProducts.updateOffer(productReference, offerReference)}`,
      {
        method: 'PUT',
        headers: authHeadersJson(),
        body: JSON.stringify({ price }),
      },
    );
    if (!response.ok) {
      throw new Error('No se pudo actualizar el precio');
    }
    return response.json();
  },

  delete: async (reference: string): Promise<void> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.supplierProducts.delete(reference)}`,
      { method: 'DELETE', headers: authHeadersForGet() },
    );
    if (!response.ok) {
      throw new Error('No se pudo eliminar el producto');
    }
  },
};
